import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const ReviewsSection = () => {
  const { t, language } = useLanguage();

  const reviews = [
    {
      name_en: 'Sarah A.',
      name_ar: 'سارة أ.',
      text_en: 'Absolutely amazing experience! The salon is clean, stylish, and very welcoming. The staff are professional and truly care about their clients. I left feeling beautiful and refreshed.',
      text_ar: 'تجربة مذهلة تمامًا! الصالون نظيف وأنيق ومرحب جدًا. الموظفات محترفات ويهتممن حقًا بالعميلات. غادرت وأنا أشعر بالجمال والانتعاش.',
      rating: 5,
    },
    {
      name_en: 'Noura M.',
      name_ar: 'نورة م.',
      text_en: 'One of the newest beauty centers with modern techniques and expert hands. They really know what they\'re doing and the results speak for themselves.',
      text_ar: 'أحد أحدث مراكز التجميل بتقنيات حديثة وأيدٍ خبيرة. إنهن يعرفن حقًا ما يفعلنه والنتائج تتحدث عن نفسها.',
      rating: 5,
    },
    {
      name_en: 'Fatima K.',
      name_ar: 'فاطمة ك.',
      text_en: 'Wonderful effort and great service! The atmosphere is so relaxing and the team made me feel at home. Will definitely be coming back.',
      text_ar: 'مجهود رائع وخدمة ممتازة! الجو مريح جدًا والفريق جعلني أشعر وكأنني في بيتي. سأعود بالتأكيد.',
      rating: 5,
    },
    {
      name_en: 'Maha S.',
      name_ar: 'مها س.',
      text_en: 'Finally found my go-to salon! The quality of service is outstanding and the prices are fair. Highly recommend for anyone looking for professional beauty services.',
      text_ar: 'أخيرًا وجدت صالوني المفضل! جودة الخدمة رائعة والأسعار معقولة. أنصح به بشدة لأي شخص يبحث عن خدمات تجميل احترافية.',
      rating: 4,
    },
  ];

  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="section-padding bg-white relative overflow-hidden"
    >
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#D4A39A]/5 rounded-full blur-3xl" />
      
      <div className="container mx-auto px-4 md:px-8 relative">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-[#D4A39A] text-sm font-semibold uppercase tracking-widest">
            {t.reviews.subtitle}
          </span>
          <h2 
            data-testid="reviews-title"
            className="heading text-3xl md:text-4xl lg:text-5xl font-bold text-[#4A4A4A] mt-3"
          >
            {t.reviews.title}
          </h2>
        </motion.div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {reviews.map((review, index) => (
            <motion.div
              key={index}
              data-testid={`review-card-${index}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="testimonial-card"
            >
              {/* Quote Icon */}
              <Quote className="w-10 h-10 text-[#D4A39A]/30 mb-4" />
              
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className={`w-5 h-5 ${
                      i < review.rating
                        ? 'text-yellow-400 fill-yellow-400'
                        : 'text-gray-300'
                    }`}
                  />
                ))}
              </div>
              
              {/* Review Text */}
              <p className="text-[#4A4A4A] leading-relaxed mb-6">
                "{language === 'ar' ? review.text_ar : review.text_en}"
              </p>
              
              {/* Reviewer Name */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-[#D4A39A] flex items-center justify-center text-white font-semibold">
                  {(language === 'ar' ? review.name_ar : review.name_en).charAt(0)}
                </div>
                <div>
                  <p className="font-semibold text-[#4A4A4A]">
                    {language === 'ar' ? review.name_ar : review.name_en}
                  </p>
                  <p className="text-sm text-[#7D7D7D]">
                    {language === 'ar' ? 'عميلة موثقة' : 'Verified Client'}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
